module.exports = function() {
  return new Worker(__webpack_public_path__ + "db47419614a5c1b6bbbc.worker.js");
};